import React from 'react';
import {CallRegion} from '@components/call-card/CallRegion';
import {CallTick} from '@components/call-card/CallTick';
import {UserComment} from 'records/UserComment';
import {Seconds} from '@store/@types/util';

interface UnsavedCallCommentProps {
  comment: UserComment;
  duration: Seconds;
}

export const UnsavedCallComment: React.FC<UnsavedCallCommentProps> = ({comment, duration}) => {
  return (
    <div className="call-comment">
      {comment.isRange() ? (
        <CallRegion
          duration={duration}
          startTime={comment.startTime}
          endTime={comment.endTime}
          type="comment"
        />
      ) : (
        <CallTick duration={duration} location={comment.startTime} type="comment" />
      )}
    </div>
  );
};
